module.exports = __webpack_public_path__ + "static/img/not_evaluated.1c45f56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/not_evaluated.png
// module id = K4md
// module chunks = 0